<template>
  <div class="dd-login-box">
    <div class="bind">
      <span class="bind_span">钉钉：<span>{{ ddBind === 1 ? '已绑定' : '未绑定' }}</span></span>
      <svg class="icon svg-icon" aria-hidden="true" width="25" height="25" @click="ddFrameLogin">
        <use :xlink:href="ddBind === 1 ? '#youkai-dingding01' : '#youkai-dingding-yuan'"></use>
      </svg>
    </div>
    <div class="ddLogin-back" v-show="ddLoginShow" @click="closeDdLogin"></div>
    <div v-show="ddLoginShow" class="ddLogin">
      <div class="ddLogin-header">
        <img style="margin-right: 6px;" src="/static/dingtalk.png" width="16" height="16">
        <span style="font-size: 16px;">钉钉扫码登录</span>
      </div>
      <div id="ddLogin2"></div>
      <div class="ddLogin-bottom">请使用钉钉扫描二维码登录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DdQrcodeLogin',
  props: {
    user: Object,
    bindState: String
  },
  data () {
    return {
      ddLoginShow: false,
      ddBind: 1,
      wwLogin: null,
      isBindDdLoing: true,
      authing: false
    }
  },
  watch: {
    user: function (val) {
      this.isBindDd()
    }
  },
  methods: {
    ddFrameLogin () {
      this.ddLoginInit()
      this.ddLoginShow = true
    },
    closeDdLogin () {
      this.ddLoginShow = false
    },
    ddLoginInit () {
      console.log(this.user.username)
      const location = window.location
      let _that = this
      window.DTFrameLogin(
        {
          id: 'ddLogin2',
          width: 320,
          height: 288
        },
        {
          redirect_uri: encodeURIComponent(`${location.protocol}//${location.host}${this.$route.fullPath}`),
          client_id: 'dingicrl2wiiwammf0kv',
          scope: 'openid',
          response_type: 'code',
          state: _that.bindState,
          prompt: 'consent'
        },
        (loginResult) => {
          const {redirectUrl, authCode, state} = loginResult
          if (_that.authing) return
          _that.authing = true
          if (state === _that.bindState) {
            _that.ddLoginCodeBind(authCode, _that.user.id)
          }
        },
        (errorMsg) => {
          alert(`Login Error: ${errorMsg}`)
        }
      )
    },
    ddLoginCodeBind (code, userId) {
      // this.authing = true
      this.$axios.post('/api/admin/ddLogin/bind', { code, userId })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.ddBind = data.data.status
            this.ddLoginShow = false
            this.authing = false
          } else {
            this.ddLoginShow = false
            this.authing = false
            this.$message.error(data.msg)
          }
        })
    },
    isBindDd () {
      this.isBindDdLoing = true
      this.$axios.get('/api/admin/isBindDd/me?userId=' + this.user.id, {loadingClose: true})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.ddBind = data.data.status
            this.isBindDdLoing = false
          }
        })
    }
  },
  mounted () {
    // this.ddLoginInit()
    this.isBindDd()
  }
}
</script>

<style lang="stylus" scoped>
.bind {
  display: flex;
}
.bind svg {
  cursor: pointer;
}
.bind_span {
  line-height: 25px;
  margin-right: 5px;
}
.ddLogin
  position: fixed
  top: 40%
  left: 51.5%
  width: 320px
  margin-top: -113.5px
  margin-left: -222px
  background: #fff
  z-index: 99999
.ddLogin-header
  display: flex
  justify-content: center
  padding-top: 40px
.ddLogin-bottom
  text-align: center
  padding-bottom: 20px
  color: #878f95
  font-weight: 400
.ddLogin-back
  width: 100%
  height: 100%
  background: #000
  opacity: 0.5
  position: fixed
  left: 0
  top: 0
  z-index: 99998
</style>



// WEBPACK FOOTER //
// src/pages/authority/common/DdQrcodeLogin.vue